import { CAMPAIGN_FORM_TITLE } from '~/constants/campaign'
import { TextField } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { FormatVersion, ReviewSection, ReviewTarget } from '~/generated/graphql'
import { CampaignInputComponent, CampaignInputComponentProps } from './CampaignInputComponent'
import { z } from 'zod'

export const offerAutoMessageSchemaFields = {
  offerAutoMessage: z.string(),
}
export const offerAutoMessageSchema = z.object(offerAutoMessageSchemaFields)

type Props = CampaignInputComponentProps

/**
 * インフルエンサー採用時に相手に送られる自動メッセージ
 * - 月額・店舗→自動生成部分を固定表示（編集させない）
 * - 月額・通販→自動生成部分は固定＋追加で自由記述 →submit時に結合
 * - 月額・通販・自社発送→チェックボックスを表示
 * - 投稿報酬      →自動生成部分含めて自由記述
 */
export const OfferAutoMessage = ({ description, tooltip }: Props) => {
  const { control } = useFormContext<z.infer<typeof offerAutoMessageSchema>>()
  return (
    <CampaignInputComponent
      title={CAMPAIGN_FORM_TITLE.offerAutoMessage}
      compatibleFormatVersions={[FormatVersion.V4Campaign]}
      review={{
        section: ReviewSection.Campaign,
        targets: [ReviewTarget.OfferAutoMessage, ReviewTarget.LegalOfferAutoMessage],
      }}
      description={description}
      tooltip={tooltip}
    >
      <Controller
        control={control}
        name="offerAutoMessage"
        render={({ field: { ref, ...field } }) => {
          return <TextField fullWidth {...field} multiline minRows={10} inputRef={ref} />
        }}
      />
    </CampaignInputComponent>
  )
}
